module.exports = __webpack_public_path__ + "img/1451031169.135bb7f8.jpg";